/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MCPTokenResponse
 */
export interface MCPTokenResponse {
  /**
   *
   * @type {string}
   * @memberof MCPTokenResponse
   */
  access: string;
  /**
   *
   * @type {string}
   * @memberof MCPTokenResponse
   */
  expiresAt: string;
  /**
   *
   * @type {string}
   * @memberof MCPTokenResponse
   */
  scope: string;
  /**
   *
   * @type {string}
   * @memberof MCPTokenResponse
   */
  name: string | null;
}

/**
 * Check if a given object implements the MCPTokenResponse interface.
 */
export function instanceOfMCPTokenResponse(value: object): value is MCPTokenResponse {
  if (!('access' in value) || value['access'] === undefined) return false;
  if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
  if (!('scope' in value) || value['scope'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function MCPTokenResponseFromJSON(json: any): MCPTokenResponse {
  return MCPTokenResponseFromJSONTyped(json, false);
}

export function MCPTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MCPTokenResponse {
  if (json == null) {
    return json;
  }
  return {
    access: json['access'],
    expiresAt: json['expires_at'],
    scope: json['scope'],
    name: json['name'],
  };
}

export function MCPTokenResponseToJSON(value?: MCPTokenResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    access: value['access'],
    expires_at: value['expiresAt'],
    scope: value['scope'],
    name: value['name'],
  };
}
